import React, { useState, useEffect } from "react";
import TopBar from "../../components/TopBar/TopBar";
import Footer from "../../components/footer/Footer";
import { MainBodyStyle } from "../../styles/MainBodyStyles";
import { fetchAuditLogs } from "../../api/AuditLogsApi";
import { toast } from "react-toastify";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);
// import { AuditLogsPageStyle } from "./AuditLogsPage.style"; // Uncomment if you add custom styles

// Mock data based on the API response format
// const mockLogs = [
//   {
//     eventTimeUtc: "2025-08-07T17:20:00Z",
//     eventId: "4d4e3c1f-8f0a-4f07-9a2a-3084d9e6b4f9",
//     appVersion: "2.0.8",
//     platform: "iOS",
//     userId: "b5ec1cc7-0b5e-44f2-ae80-d00f2b08cce2",
//     userRole: 0,
//     eventType: "Search",
//     eventCategory: "Navigation",
//     eventName: "DoctorSearch",
//     context: {
//       device: {
//         os: "iOS 15.7",
//         build: "19H321",
//         model: "iPhone 11"
//       },
//       location: {
//         lat: 35.6895,
//         lon: 139.6917
//       },
//       networkStatus: "WiFi"
//     },
//     outcome: "Success"
//   },
//   {
//     eventTimeUtc: "2025-08-07T17:05:50Z",
//     eventId: "e9f2f59e-c423-46b1-bb7f-f5f8b712e7a3",
//     appVersion: "2.1.3",
//     platform: "Android",
//     userId: "f0a0d9e3-8c5e-47c0-b0cb-91f74edebc37",
//     userRole: 3,
//     eventType: "FormSubmit",
//     eventCategory: "DataEntry",
//     eventName: "PatientAdmissionForm",
//     context: {
//       device: {
//         os: "Android 14",
//         build: "UPB6.230625.002",
//         model: "Xiaomi 13"
//       },
//       location: {
//         lat: 41.9028,
//         lon: 12.4964
//       },
//       networkStatus: "5G"
//     },
//     outcome: "Success"
//   },
//   {
//     eventTimeUtc: "2025-08-07T16:30:30Z",
//     eventId: "9f7826c8-7e69-4cf2-b7e1-7f5fd78e61f1",
//     appVersion: "2.0.9",
//     platform: "iOS",
//     userId: "9bb0a243-b2c1-4fcb-8894-4b47b89676a5",
//     userRole: 1,
//     eventType: "ProfileUpdate",
//     eventCategory: "User",
//     eventName: "ChangeProfilePicture",
//     context: {
//       device: {
//         os: "iOS 16.6",
//         build: "20G81",
//         model: "iPhone 12"
//       },
//       location: {
//         lat: 55.7558,
//         lon: 37.6173
//       },
//       networkStatus: "WiFi"
//     },
//     outcome: "Success"
//   },
//   {
//     eventTimeUtc: "2025-08-07T16:10:10Z",
//     eventId: "cc68fd47-ccbe-4f50-96d7-784c1792ac4b",
//     appVersion: "2.1.5",
//     platform: "Android",
//     userId: "c3d19e9c-df45-4824-b41e-c0db31755f13",
//     userRole: 2,
//     eventType: "NotificationReceived",
//     eventCategory: "Push",
//     eventName: "AppointmentReminder",
//     context: {
//       device: {
//         os: "Android 13",
//         build: "TQ2A.230505.002",
//         model: "Pixel 6"
//       },
//       location: {
//         lat: -33.8688,
//         lon: 151.2093
//       },
//       networkStatus: "4G"
//     },
//     outcome: "Success"
//   },
//   {
//     eventTimeUtc: "2025-08-07T15:55:15Z",
//     eventId: "a6b6e921-bb8f-4b43-90e5-d07d5d3a94f5",
//     appVersion: "2.2.0",
//     platform: "iOS",
//     userId: "76a28c35-982a-4c77-9f1f-4c06b64340fd",
//     userRole: 0,
//     eventType: "DataUpload",
//     eventCategory: "Sync",
//     eventName: "VitalsDataUpload",
//     context: {
//       device: {
//         os: "iOS 17.1",
//         build: "21A5506d",
//         model: "iPad Pro"
//       },
//       location: {
//         lat: 19.076,
//         lon: 72.8777
//       },
//       networkStatus: "WiFi"
//     },
//     outcome: "Success"
//   }
// ];

const eventTypes = ["All", "SignIn", "SignOut", "Acknowledgement", "AlertGenerated", "AlertReceived", "AlertCanceled"];
const outcomes = ["All", "Success", "Failure"];
const platforms = ["All", "iOS", "Android", "API"];
const eventCategories = ["All", "Authentication", "Account", "TapAssist", "TapAssistRecipient"];
const eventNames = ["All", "SignIn_Manual", "SignIn_Biometric", "SignOut_Manual", "SignOut_Auto", "LicenseAgreement_Accept", "LicenseAgreement_Decline", "TapAssist", "Emergency", "Call 911", "Active Shooter", "Feeling Unsafe"];

const AuditLogsPage = () => {
  // State for API data
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 50,
    total: 0
  });

  // Filter states
  const [search, setSearch] = useState("");
  const [eventType, setEventType] = useState("All");
  const [eventName, setEventName] = useState("All");
  const [outcome, setOutcome] = useState("All");
  const [platform, setPlatform] = useState("All");
  const [eventCategory, setEventCategory] = useState("All");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [expandedRow, setExpandedRow] = useState(null);
  const [shouldClearFilters, setShouldClearFilters] = useState(false);

  // Fetch logs from API
  const fetchLogs = async () => {
    setLoading(true);
    try {
      const params = {
        page: pagination.page,
        pageSize: pagination.pageSize,
      };

      // Add filters if they are set
      if (dateFrom) {
        // Create UTC date with start of day time (00:00:00)
        params.from = dateFrom + 'T00:00:00.000Z';
      }
      if (dateTo) {
        // Create UTC date with end of day time (23:59:59)
        params.to = dateTo + 'T23:59:59.999Z';
      }
      if (eventType !== "All") params.eventType = eventType;
      if (eventName !== "All") params.eventName = eventName;
      if (outcome !== "All") params.outcome = outcome;
      if (platform !== "All") params.platform = platform;
      if (eventCategory !== "All") params.eventCategory = eventCategory;
      if (search) params.Email = search; // Search by email only

      const response = await fetchAuditLogs(params);
      setLogs(response.items || []);
      setPagination(prev => ({
        ...prev,
        total: response.total || 0
      }));
    } catch (error) {
      console.error("Error fetching audit logs:", error);
      toast.error("Failed to fetch audit logs", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    } finally {
      setLoading(false);
    }
  };

  // Fetch logs on component mount and when filters change
  useEffect(() => {
    fetchLogs();
  }, [pagination.page, pagination.pageSize]);

  // Handle clear filters trigger
  useEffect(() => {
    if (shouldClearFilters) {
      fetchLogs();
      setShouldClearFilters(false);
    }
  }, [shouldClearFilters]);

  // Apply filters
  const handleApplyFilters = () => {
    setPagination(prev => ({ ...prev, page: 1 })); // Reset to first page
    fetchLogs();
  };

  // Clear filters
  const handleClearFilters = () => {
    setSearch("");
    setEventType("All");
    setEventName("All");
    setOutcome("All");
    setPlatform("All");
    setEventCategory("All");
    setDateFrom("");
    setDateTo("");
    setPagination(prev => ({ ...prev, page: 1 }));
    setShouldClearFilters(true); // Trigger fetch after state updates
  };

  // Handle pagination
  const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, page: newPage }));
  };

  // Summary stats
  const totalEvents = logs.length;
  const successCount = logs.filter((l) => l.outcome === "Success").length;
  const failureCount = logs.filter((l) => l.outcome === "Failure").length;
  const successRatio = totalEvents ? Math.round((successCount / totalEvents) * 100) : 0;

  // Donut chart configuration
  const chartData = {
    labels: ['Success', 'Failure'],
    datasets: [
      {
        data: [successCount, failureCount],
        backgroundColor: [
          '#28a745', // Green for success
          '#dc3545', // Red for failure
        ],
        borderColor: '#ffffff',
        borderWidth: 3,
        hoverBackgroundColor: [
          '#218838', // Darker green on hover
          '#c82333', // Darker red on hover
          '#e0a800', // Darker yellow on hover
          '#5a6268', // Darker gray on hover
        ],
        hoverBorderWidth: 4,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          padding: 15,
          font: {
            size: 11,
            weight: 'bold'
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.parsed;
            const percentage = totalEvents ? Math.round((value / totalEvents) * 100) : 0;
            return `${label}: ${value} events (${percentage}%)`;
          }
        }
      }
    },
    cutout: '65%', // This makes it a donut instead of pie
    elements: {
      arc: {
        borderWidth: 0
      }
    }
  };

  return (
    // <AuditLogsPageStyle> // Uncomment if you add custom styles
    <>
      <TopBar authorized={true} />
      <MainBodyStyle>
        <div className="configurationCardWidth configurationCard" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2>Audit Logs</h2>
          
          {/* Main Layout: Filters on Left, Stats & Chart on Right */}
          <div style={{ display: "flex", gap: 244, marginBottom: 16, alignItems: "flex-start",  maxWidth: '1200px', margin: '0 auto' }}>
            
            {/* Left Side - Filters */}
            <div style={{ flex: 1, minWidth: 400 }}>
              <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 16 }}>
                <input
                  type="text"
                  placeholder="Search by email"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="form-control input-field"
                  style={{ minWidth: 200 }}
                />
                <select value={eventType} onChange={e => setEventType(e.target.value)} className="form-control input-field">
                  {eventTypes.map(type => <option key={type} value={type}>Event: {type}</option>)}
                </select>
                <select value={eventName} onChange={e => setEventName(e.target.value)} className="form-control input-field">
                  {eventNames.map(name => <option key={name} value={name}>Event Name: {name}</option>)}
                </select>
                <select value={outcome} onChange={e => setOutcome(e.target.value)} className="form-control input-field">
                  {outcomes.map(type => <option key={type} value={type}>Outcome: {type}</option>)}
                </select>
                <select value={platform} onChange={e => setPlatform(e.target.value)} className="form-control input-field">
                  {platforms.map(type => <option key={type} value={type}>Platform: {type}</option>)}
                </select>
                <select value={eventCategory} onChange={e => setEventCategory(e.target.value)} className="form-control input-field">
                  {eventCategories.map(type => <option key={type} value={type}>Category: {type}</option>)}
                </select>
                <input
                  type="date"
                  value={dateFrom}
                  onChange={e => setDateFrom(e.target.value)}
                  className="form-control input-field"
                  placeholder="From Date"
                />
                <input
                  type="date"
                  value={dateTo}
                  onChange={e => setDateTo(e.target.value)}
                  className="form-control input-field"
                  placeholder="To Date"
                />
                <button 
                  className="btn" 
                  onClick={handleApplyFilters}
                  disabled={loading}
                  style={{
                    backgroundColor: "#f28809",
                    color: "white",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    cursor: loading ? "not-allowed" : "pointer",
                    opacity: loading ? 0.7 : 1
                  }}
                >
                  Apply Filters
                </button>
                <button 
                  className="btn" 
                  onClick={handleClearFilters}
                  disabled={loading}
                  style={{
                    backgroundColor: "#6c757d",
                    color: "white",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    cursor: loading ? "not-allowed" : "pointer",
                    opacity: loading ? 0.7 : 1
                  }}
                >
                  Clear
                </button>
              </div>
            </div>

            {/* Right Side - Statistics and Chart */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: 300 }}>
              {/* Statistics */}
              <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginBottom: 16, justifyContent: "center" }}>
                <div><b>Total Events:</b> {pagination.total}</div>
                <div><b>Current Page Events:</b> {totalEvents}</div>
                <div><b>Success:</b> {successCount}</div>
                <div><b>Failure:</b> {failureCount}</div>
                {loading && <div style={{ color: "#f28809" }}>Loading...</div>}
              </div>
              
              {/* Donut Chart */}
              {totalEvents > 0 && (
                <div style={{ width: 220, height: 220 }}>
                  <h4 style={{ textAlign: 'center', marginBottom: 10, fontWeight: 'bold' }}>Success vs Failure Ratio:</h4>
                  <Doughnut data={chartData} options={chartOptions} />
                </div>
              )}
            </div>
            
          </div>
        </div>

        {/* Table Section - Full Width covering entire horizontal area */}
        <div style={{ 
          width: '100vw',
          position: 'relative',
          left: '50%',
          right: '50%',
          marginLeft: '-50vw',
          marginRight: '-50vw',
          paddingLeft: '20px',
          paddingRight: '20px',
          marginTop: '20px',
          marginBottom: '20px',
          boxSizing: 'border-box'
        }}>
          {/* Log Table */}
          <div style={{ overflowX: 'auto', marginTop: '16px' }}>
            <table className="table-div" style={{ width: 'max-content', minWidth: '100%', tableLayout: 'auto' }}>
              <thead>
                <tr>
                  <th style={{ minWidth: '140px', padding: '8px', textAlign: 'left' }}>Event Time</th>
                  <th style={{ minWidth: '280px', padding: '8px', textAlign: 'left' }}>User ID</th>
                  <th style={{ minWidth: '280px', padding: '8px', textAlign: 'left' }}>Initiated By</th>
                  <th style={{ minWidth: '200px', padding: '8px', textAlign: 'left' }}>Email</th>
                  <th style={{ minWidth: '110px', padding: '8px', textAlign: 'left' }}>Event Type</th>
                  <th style={{ minWidth: '150px', padding: '8px', textAlign: 'left' }}>Event Name</th>
                  <th style={{ minWidth: '80px', padding: '8px', textAlign: 'left' }}>Platform</th>
                  <th style={{ minWidth: '120px', padding: '8px', textAlign: 'left' }}>Category</th>
                  <th style={{ minWidth: '80px', padding: '8px', textAlign: 'left' }}>Outcome</th>
                  <th style={{ minWidth: '100px', padding: '8px', textAlign: 'left' }}>App Version</th>
                  <th style={{ minWidth: '80px', padding: '8px', textAlign: 'left' }}>Details</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <React.Fragment key={log.eventId}>
                    <tr style={{ background: log.outcome === "Failure" ? "#ffeaea" : undefined }}>
                      <td style={{ padding: '8px', whiteSpace: 'nowrap' }}>
                        {new Date(log.eventTimeUtc).toLocaleString()}
                      </td>
                      <td style={{ padding: '8px', whiteSpace: 'nowrap' }}>
                        {log.userId || 'N/A'}
                      </td>
                      <td style={{ padding: '8px', whiteSpace: 'nowrap' }}>
                        {log.initiatedBy && log.initiatedBy !== null && log.initiatedBy !== '' ? log.initiatedBy : 'N/A'}
                      </td>
                      <td style={{ padding: '8px', whiteSpace: 'nowrap' }}>
                        {log.email && log.email !== null && log.email !== '' ? log.email : 'N/A'}
                      </td>
                      <td style={{ padding: '8px', whiteSpace: 'nowrap' }}>
                        {log.eventType}
                      </td>
                      <td style={{ padding: '8px', whiteSpace: 'nowrap' }}>
                        {log.eventName}
                      </td>
                      <td style={{ padding: '8px', whiteSpace: 'nowrap' }}>
                        {log.platform}
                      </td>
                      <td style={{ padding: '8px', whiteSpace: 'nowrap' }}>
                        {log.eventCategory}
                      </td>
                      <td style={{ color: log.outcome === "Success" ? "green" : "red", padding: '8px', whiteSpace: 'nowrap' }}>
                        {log.outcome}
                      </td>
                      <td style={{ padding: '8px', whiteSpace: 'nowrap' }}>
                        {log.appVersion}
                      </td>
                      <td>
                        <button
                          className="btn btn-sm"
                          onClick={() => setExpandedRow(expandedRow === log.eventId ? null : log.eventId)}
                        >
                          {expandedRow === log.eventId ? "Hide" : "View"}
                        </button>
                      </td>
                    </tr>
                    {expandedRow === log.eventId && (
                      <tr>
                        <td colSpan={11} style={{ background: "#f9f9f9", padding: "10px" }}>
                          <div><b>Event ID:</b> {log.eventId}</div>
                          <div><b>User Role:</b> {log.userRole}</div>
                          <div><b>Email:</b> {log.email && log.email !== null && log.email !== '' ? log.email : 'N/A'}</div>
                          <div><b>Initiated By:</b> {log.initiatedBy && log.initiatedBy !== null && log.initiatedBy !== '' ? log.initiatedBy : 'N/A'}</div>
                          <div><b>Full User ID:</b> {log.userId || 'N/A'}</div>
                          {log.context && (
                            <>
                              {log.context.device && (
                                <div><b>Device:</b> {log.context.device.model} ({log.context.device.os})</div>
                              )}
                              {log.context.networkStatus && (
                                <div><b>Network:</b> {log.context.networkStatus}</div>
                              )}
                              {log.context.location && (
                                <div><b>Location:</b> {log.context.location.lat}, {log.context.location.lon}</div>
                              )}
                            </>
                          )}
                          {typeof log.context === 'string' && (
                            <div><b>Context:</b> <pre style={{ whiteSpace: 'pre-wrap', fontSize: '12px' }}>{log.context}</pre></div>
                          )}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
                {logs.length === 0 && !loading && (
                  <tr>
                    <td colSpan={11} style={{ textAlign: "center", color: "#888" }}>No logs found.</td>
                  </tr>
                )}
                {loading && (
                  <tr>
                    <td colSpan={11} style={{ textAlign: "center", color: "#f28809" }}>Loading audit logs...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 16 }}>
            <div>
              Page {pagination.page} of {Math.ceil(pagination.total / pagination.pageSize)} 
              {" "}({pagination.total} total records)
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button 
                className="btn btn-secondary"
                onClick={() => handlePageChange(pagination.page - 1)}
                disabled={pagination.page <= 1 || loading}
              >
                Previous
              </button>
              <button 
                className="btn btn-secondary"
                onClick={() => handlePageChange(pagination.page + 1)}
                disabled={pagination.page >= Math.ceil(pagination.total / pagination.pageSize) || loading}
              >
                Next
              </button>
            </div>
          </div>
        </div>

      </MainBodyStyle>
      <Footer />
    </>
    // </AuditLogsPageStyle>
  );
};

export default AuditLogsPage;
